import React from 'react';
import { scrollToPurchase } from '../utils/checkout';
export function BonusesSection() {
  const bonuses = [{
    num: 1,
    title: '30 Sit-Snap-Shoot Cheat Sheets',
    img: 'https://cdn.magicpatterns.com/uploads/49zvbTkdjAqvHwwBQTgzBH/Untitled_design_(1).png',
    desc: 'Simple photo recipes you can follow step by step with your own dog — so you never have to wonder what to try next.'
  }, {
    num: 2,
    title: '7 Lightroom Editing Walkthroughs',
    img: 'https://cdn.magicpatterns.com/uploads/3NDmUJE4RXRqg5ohZ3mbCc/Untitled_design_(2).png',
    desc: 'Easy, beginner-friendly edits to make your dog photos look cleaner, warmer, and more polished — without turning editing into a headache.'
  }, {
    num: 3,
    title: 'Photo Settings & Setup Guide',
    img: 'https://cdn.magicpatterns.com/uploads/isApy6HmHRdLWE3CjxjeFD/Untitled_design_(3).png',
    desc: 'A practical reference guide that helps you set up light, angle, and phone mode more confidently before you even take the shot.'
  }];
  return <section className="bg-gradient-to-b from-[#1a1208] via-[#1f160c] to-[#1a1208] py-20 md:py-28 px-4 text-white" data-id="element-56">
      <div className="max-w-4xl mx-auto" data-id="element-57">
        {/* Section 17 — Bonuses Intro */}
        <div className="text-center mb-16" data-id="element-58">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-soft-gold mb-4" data-id="element-59">
            🎁 Get 3 Free Bonuses Today
          </h2>
          <p className="font-sans text-lg md:text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed" data-id="element-60">
            These bonuses are designed to help you get faster results, feel more
            confident, and use what you learn right away.
          </p>
        </div>

        {/* Sections 18–20 — Individual Bonuses */}
        <div className="space-y-12" data-id="element-61">
          {bonuses.map(bonus => <div key={bonus.num} className="bg-white/5 backdrop-blur-sm rounded-2xl border border-soft-gold/20 overflow-hidden" data-id="element-62">
              {/* Bonus header */}
              <div className="px-6 pt-6 md:px-8 md:pt-8" data-id="element-63">
                <p className="font-sans font-medium text-soft-gold uppercase tracking-wider text-xs md:text-sm mb-4" data-id="element-64">
                  Bonus #{bonus.num} — {bonus.title}
                </p>
              </div>

              {/* Bonus image */}
              <div className="px-6 md:px-8 cursor-pointer group" onClick={scrollToPurchase} data-id="element-65">
                <a href="#purchase" onClick={scrollToPurchase} className="block" data-id="element-66">
                  <img src={bonus.img} alt={`Bonus ${bonus.num}: ${bonus.title}`} className="w-full max-w-md mx-auto rounded-xl shadow-lg transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-67" />
                </a>
              </div>

              {/* Bonus description */}
              <div className="px-6 pb-6 pt-5 md:px-8 md:pb-8" data-id="element-68">
                <p className="font-sans text-base md:text-lg text-gray-300 leading-relaxed text-center max-w-lg mx-auto" data-id="element-69">
                  {bonus.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}